const domain = window.location.host;
let FOOTER_ENV = ""

const FOOTER_URLS_BASE = {
  DEV: "https://gcom.pdodev.aws.gartner.com",
  QA: "https://gcom.pdoqa.aws.gartner.com",
  PROD: "https://www.gartner.com",
};

const FOOTER_URLS = {
  POLICIES: "/en/about/policies/overview",
  PRIVACY_POLICY: "/en/about/policies/privacy",
  TERMS_OF_USE: "/en/about/policies/terms-of-use",
  OMBUDS: "/en/about/ombuds"
};

const HOST = {
  DEV: "tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com",
  QA: "tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com"
};

if (HOST.DEV.indexOf(domain) !== -1) {
  FOOTER_ENV = FOOTER_URLS_BASE.DEV;
} else if (HOST.QA.indexOf(domain) !== -1) {
  FOOTER_ENV = FOOTER_URLS_BASE.QA;
} else {
  FOOTER_ENV = FOOTER_URLS_BASE.PROD;
}

export const Constants = {
  ROUTES: {
    BASE_URL: "/",
  },
  FOOTER_LINKS: [
    {
      url: FOOTER_ENV + FOOTER_URLS.POLICIES,
      label: 'POLICIES',
    },
    {
      url: FOOTER_ENV + FOOTER_URLS.PRIVACY_POLICY,
      label: 'PRIVACY POLICY',
    },
    {
      url: FOOTER_ENV + FOOTER_URLS.TERMS_OF_USE,
      label: 'TERMS OF USE',
    },
    {
      url: FOOTER_ENV + FOOTER_URLS.OMBUDS,
      label: 'OMBUDS'
    },
  ],
};
